<template>
    <div>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <br>
        <br>
        <h3>
          <router-link title="Navigate to the home page" :to="{name: 'home'}" v-b-tooltip.hover.bottom>Home page</router-link>
          <span v-if="!authenticatedUser"> |
            <router-link title="Login to your account" :to="{name: 'login'}" v-b-tooltip.hover.bottom>Login</router-link>
          </span>
          <span v-if="!authenticatedUser"> |
            <router-link title="Create an account" :to="{name: 'signup'}" v-b-tooltip.hover.bottom>Sign Up</router-link>
          </span>
        </h3>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'NoAccess.vue',
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NoAccess.vue